import { motion } from 'framer-motion'

interface Props {
  accentSoft?: string
}

const TESTIMONIAL_IMAGES = [
  {
    src: 'https://static.lumi.new/dd/ddccb55b5e5326845dd559c7ea267859.webp',
    alt: 'Depoimento da Vitoria sobre o Mapa de Cura dos 4 Elementos — transformacao e clareza sobre padroes internos',
  },
  {
    src: 'https://static.lumi.new/cc/cc992641794d116dbc2eb07bc7277890.webp',
    alt: 'Depoimento da Fatima Verona sobre o Mapa de Cura dos 4 Elementos — emocao e movimento de transformacao',
  },
]

function MapaWhatsappTestimonials({ accentSoft = '#B9A3D9' }: Props) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: '-80px' }}
      transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
      className="my-8 md:my-10"
    >
      <div className="text-center mb-6 md:mb-8">
        <p
          className="text-[10px] tracking-[0.4em] uppercase font-body mb-3"
          style={{ color: accentSoft }}
        >
          Depoimentos reais
        </p>
        <h3
          className="font-display text-[var(--ink)]"
          style={{
            fontSize: 'clamp(1.35rem, 3vw, 1.75rem)',
            lineHeight: 1.35,
            fontWeight: 500,
          }}
        >
          O que estão dizendo sobre o{' '}
          <em className="italic font-light" style={{ color: accentSoft }}>
            Mapa de Cura dos{' '}
            <span className="numerals">4</span> Elementos
          </em>
        </h3>
        <div
          className="h-px w-20 mx-auto mt-5"
          style={{
            background: `linear-gradient(90deg, transparent, ${accentSoft}66, transparent)`,
          }}
        />
      </div>

      {/* Layout: empilhado em mobile, lado a lado em desktop (2 prints) */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-5 md:gap-6 max-w-3xl mx-auto">
        {TESTIMONIAL_IMAGES.map((img, i) => (
          <motion.div
            key={i}
            initial={{ opacity: 0, y: 16 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: '-60px' }}
            transition={{ duration: 0.7, delay: i * 0.12, ease: [0.22, 1, 0.36, 1] }}
            className="overflow-hidden rounded-2xl"
            style={{
              background: 'rgba(255,255,255,0.02)',
              border: '1px solid rgba(255,255,255,0.06)',
              boxShadow: '0 8px 24px rgba(0,0,0,0.28), 0 2px 6px rgba(0,0,0,0.18)',
            }}
          >
            <img
              src={img.src}
              alt={img.alt}
              loading="lazy"
              className="block w-full h-auto"
              style={{ display: 'block' }}
            />
          </motion.div>
        ))}
      </div>
    </motion.div>
  )
}

export default MapaWhatsappTestimonials
